module.exports = __webpack_public_path__ + "img/sakr-stamp.6cae790e.png";